import type * as Y from 'yjs';
import { boardTypes, type BoardEditMarker } from './model.ts';
import { BoardView } from './renderer.ts';

export interface TvBoard {
  canvas: HTMLCanvasElement;
  dispose(): void;
}

export function mountTvBoard(host: HTMLElement, doc: Y.Doc, roomCode: string, onPaint: (markers: readonly BoardEditMarker[]) => void): TvBoard {
  host.innerHTML = `
    <section class="tv-surface">
      <canvas data-tv-board aria-label="Shared Mirror Loop TV surface"></canvas>
      <div class="display-seat-label" data-display-seat-label>Display seat · ${roomCode}</div>
      <div class="tv-surface-status"><span></span><b>LIVE SURFACE</b><small>Use game / PC mode for the lowest display latency.</small></div>
    </section>`;
  const canvas = host.querySelector<HTMLCanvasElement>('[data-tv-board]')!;
  const board = boardTypes(doc);
  const view = new BoardView(canvas, board, { onPaint: (markers) => {
    onPaint(markers);
    if (markers.length > 0) doc.transact(() => {
      for (const marker of markers) board.editMarkers.delete(marker.editId);
    }, 'measurement-prune');
  } });
  return { canvas, dispose: () => view.dispose() };
}
